import type { ReactNode } from 'react';
import Modal from './Modal';

/**
 * Разбор — второй примитив админки.
 *
 * Всё, чего нет в строке. На широком экране окно, на телефоне шторка
 * снизу: одно и то же содержимое, та же шапка, тот же порядок блоков.
 * Это уже умеет `Modal`, поэтому здесь надстройка, а не второе окно.
 *
 * Что добавляется: **действия закреплены внизу**. Раньше они лежали
 * россыпью по карточке — «Забанить» под контактами, «Сменить пароль» под
 * паролем, «Назначить владельцем» в составе компании, — и до нужного
 * приходилось листать содержимое целиком. У постоянного места есть
 * простое свойство: его не ищут.
 */

interface Props {
  open: boolean;
  onClose: () => void;
  /** Кто или что разбирается: имя и строка уточнения под ним. */
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  /** Кнопки внизу. Порядок слева направо, опасное — крайним. */
  actions?: ReactNode;
}

export default function AdminSheet({
  open,
  onClose,
  title,
  subtitle,
  children,
  actions,
}: Props) {
  return (
    <Modal open={open} onClose={onClose} title={title}>
      {subtitle && <div className="asheet__sub">{subtitle}</div>}

      {/*
       * Содержимое прокручивается, полоса действий — нет. На телефоне
       * это разница между «нажал» и «пролистал состав из сорока человек,
       * чтобы нажать».
       */}
      <div className="asheet__body">{children}</div>

      {actions && <div className="asheet__acts">{actions}</div>}
    </Modal>
  );
}
